import { Config } from "@/shared/config";

const payrollServiceUri = Config.PayrollServicebaseUri;
export default {
  payrollContactInformation (employerId: number): string {
    return payrollServiceUri + `/payroll/v1/employer/${employerId}/contact`;
  },
  payrollInformation (employerId: number): string {
    return payrollServiceUri + `/payroll/v1/employer/${employerId}`;
  },
  planDetail (employerId: number): string {
    return payrollServiceUri + `/payroll/v1/employer/${employerId}/plandetail`;
  },
  getPayrollReportDates (employerId: number, automatedLeaveDate: string) {
    const leaveDateOrEmptyString = (automatedLeaveDate !== null) ? `?automatedFundingMethodLeaveDate=${automatedLeaveDate}` : "";
    return payrollServiceUri + `/payroll/v1/employer/${employerId}/payrollreportDates${leaveDateOrEmptyString}`;
  },
  payrollDates (employerId: number, year: number) {
    return payrollServiceUri + `/payroll/v1/employer/${employerId}/paydates/${year}`;
  },
  downloadPayrollChangeReport (employerId: number, payrollDate: string) {
    return payrollServiceUri + `/payroll/v1/employer/${employerId}/payrollreport?payrollDate=${payrollDate}`;
  },
  downloadPayrollFullReport (employerId: number, payrollDate: string) {
    return payrollServiceUri + `/payroll/v1/employer/${employerId}/fullpayrollreport?payrollDate=${payrollDate}`;
  },
  userContribution (): string {
    return payrollServiceUri + "/payroll/v1/user/contribution";
  },
  getPayrollContributionsDashboardGraph (employerId: number, page: number) {
    return `${payrollServiceUri}/payroll/v1/employer/${employerId}/contributions-graph?page=${page}`;
  },
  getPredictedContributions () {
    return `${payrollServiceUri}/payroll/v1/user/contributions/predicted`;
  },
  updateRecurringEmployeeContribution (): string {
    return payrollServiceUri + `/payroll/v1/user/updateemployeerecurring`;
  },
  getUserPayrollSummary (): string {
    return payrollServiceUri + `/payroll/v1/user/userpayrollsummary`;
  },
  getUserPayrollSummaryPersonalScheduledContributions (): string {
    return payrollServiceUri + `/payroll/v1/user/userpayrollsummary/personalscheduledcontributions`;
  },
  getUserLiftContribution (payrollDate: string): string {
    return payrollServiceUri + `/payroll/v1/user/${payrollDate}/userliftcontribution`;
  },
  getEmployeeContributions (pageSize: number, page: number, employerId: number, search: string): string {
    return payrollServiceUri +
      `/payroll/v1/employer/${employerId}/employeecontributions/${page}` +
      `?pageSize=${pageSize}&search=${encodeURIComponent(search)}`;
  },
  updateEmployeeContribution (payrollDate: string, employerId: number): string {
    return payrollServiceUri + `/payroll/v1/employer/${employerId}/${payrollDate}/employeecontribution`;
  },
  getPayrollDateAndCutoffDate (employerId: number): string {
    return `${payrollServiceUri}/payroll/v1/employer/${employerId}/payrolldateandcutoffdate`;
  },
  getEmployeeYearToDatePayroll (employerId: number, employeeId: string) {
    return `${payrollServiceUri}/payroll/v1/employer/${employerId}/payroll-year-to-date?employeeId=${employeeId}`;
  },
  getEmployerUpcomingPayrolls (employerId: number, noOfPayrolls: number) {
    return `${payrollServiceUri}/payroll/v1/employer/${employerId}/upcomingpayrolls?noOfUpcomingPayrolls=${noOfPayrolls}`;
  },
  getEmployeeContributionsByYear (employerId: number, year: number) {
    return `${payrollServiceUri}/payroll/v1/employer/${employerId}/employee-contribution-total/${year}`;
  },
  getEmployeePlanYearContributionsList (employerId: number, employeeId: number, pageNumber: number) {
    return `${payrollServiceUri}/payroll/v1/employer/${employerId}/employeeplanyearcontribution/${employeeId}/list/${pageNumber}`;
  },
  getEmployeePlanYearToDateContributionSummary (employerId: number, employeeId: number) {
    return `${payrollServiceUri}/payroll/v1/employer/${employerId}/employeeplanyearcontribution/${employeeId}/summary`;
  },
  getBankHolidaysInYear (year: number) {
    return `${payrollServiceUri}/payroll/v1/bank-holidays/${year}`;
  },
  scheduledPersonalContribution () {
    return `${payrollServiceUri}/payroll/v1/user/scheduled-personal-contribution`;
  },
  validateEmployerPaydatesByYear ({ employerId, year }: { employerId: number, year: number }) {
    return `${payrollServiceUri}/payroll/v1/employer/${employerId}/paydates/${year}/validate`;
  },
  fundingOption (employerId: number) {
    return `${payrollServiceUri}/payroll/v1/employer/${employerId}/funding-option`;
  },
  getOtherHsaCutOffDate () {
    return `${payrollServiceUri}/payroll/v1/user/otherhsa-prior-year-cutoff-date`;
  }
};
